import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useMemo } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import MessagesModal from "../MessagesModal/MessagesModal";
import { useAppContext } from "../../../context/app-context";
import { ApiPaths } from "../../../api/paths";
import useData from "../../../hooks/use-data";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

export default function AuthenticatedLayout() {
  const { t } = useTranslation(["myProfile"]);
  const { keycloak } = useKeycloak();
  const { keycloakProfile, setProfilePic } = useAppContext();
  const navigate = useNavigate();

  const profileParams = useMemo(
    () => ({
      params: {
        search: keycloakProfile?.email,
      },
    }),
    [keycloakProfile?.email]
  );

  const { data } = useData<any>(`${ApiPaths.profilePicture}`, {
    options: profileParams,
    onError: () => {
      toast(t("mutate_Profile.error.fetch_single", { ns: "myProfile" }), {
        type: "error",
      });
    },
    fetchIf: !!keycloakProfile?.email,
  });

  useEffect(() => {
    if (data) {
      setProfilePic(data);
    }
  }, [data]);

  useEffect(() => {
    if (keycloak.authenticated === false) {
      navigate("/");
    }
    if (
      (keycloak.authenticated === true &&
        keycloakProfile?.admin_approved === "PENDING") ||
      keycloakProfile?.admin_approved === "INFO_REQUESTED"
    ) {
      navigate("/validate");
    }
  }, [keycloak.authenticated]);

  if (!keycloak.authenticated) {
    return <></>;
  }

  return (
    <>
      <Header />
      <Sidebar />
      <div className="main-container">
        <Outlet />
      </div>
      <MessagesModal />
    </>
  );
}
